/* Zevrolla Atelier — theme behaviour. Vanilla, no dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  const formatMoney = (cents) => {
    const fmt = window.zevMoneyFormat || '£{{amount}}';
    const value = (Number(cents) / 100);
    const withDelims = (n, dec, th = ',', d = '.') => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(d);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0);
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2);
      }
    });
  };
  window.zevFormatMoney = formatMoney;

  /* ---------- Reveal choreography ---------- */
  const revealIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target;
      el.classList.add('in');
      if (el.classList.contains('stagger')) {
        setTimeout(() => el.classList.add('done'), 1600);
      }
      revealIO.unobserve(el);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
  const armReveals = (root = document) => $$('.reveal, .stagger, .stitch-rule', root).forEach((el) => revealIO.observe(el));
  armReveals();
  document.addEventListener('shopify:section:load', (e) => armReveals(e.target));

  /* ---------- Pause loops on hidden tabs ---------- */
  document.addEventListener('visibilitychange', () => {
    document.body.classList.toggle('paused', document.hidden);
  });

  /* ---------- Header ---------- */
  const headerWrap = $('.site-header-wrap');
  const header = $('.site-header');
  if (headerWrap && header) {
    const headerSection = headerWrap.closest('.header-section') || headerWrap.parentElement;
    const overlay = headerWrap.classList.contains('is-overlay');
    const announce = $('.announcement');
    const hero = $('.scroll-hero');
    let lastY = scrollY;
    let ticking = false;
    let scrolled = null;
    let hidden = null;
    let lastTop = -1;
    const solidAt = () => (overlay && hero ? hero.offsetTop + hero.offsetHeight - header.offsetHeight : 40);
    const update = () => {
      ticking = false;
      const y = scrollY;
      if (overlay) {
        const top = Math.max(0, (announce ? announce.offsetHeight : 0) - y);
        if (top !== lastTop) { lastTop = top; headerSection.style.setProperty('--hdr-top', `${top}px`); }
      }
      const nowScrolled = y > solidAt();
      if (nowScrolled !== scrolled) { scrolled = nowScrolled; header.classList.toggle('scrolled', nowScrolled); }
      const goingDown = y > lastY && y > 400;
      const nowHidden = goingDown && !document.body.classList.contains('drawer-open');
      if (nowHidden !== hidden) { hidden = nowHidden; header.classList.toggle('hidden-up', nowHidden); }
      lastY = y;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    addEventListener('resize', update);
    update();
  }

  /* ---------- Mobile menu ---------- */
  const menu = $('#MobileMenu');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => {
    menu?.classList.add('open');
    menu?.querySelector('a, button')?.focus();
    document.documentElement.style.overflow = 'hidden';
  }));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => {
    menu?.classList.remove('open');
    document.documentElement.style.overflow = '';
  }));

  /* ---------- The Seam: a running stitch that sews down the page ---------- */
  const seam = $('.seam');
  if (seam) {
    let raf = null;
    let last = -1;
    let lastDark = null;
    const darkSections = () => $$('.scheme-green, .scheme-deep, .scroll-hero');
    const drive = () => {
      raf = null;
      const max = document.documentElement.scrollHeight - innerHeight;
      const p = max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0;
      const r = Math.round(p * 1000) / 1000;
      if (r !== last) { last = r; seam.style.setProperty('--seam', r); }
      const probeY = innerHeight * (0.12 + p * 0.76);
      const onDark = darkSections().some((s) => { const b = s.getBoundingClientRect(); return b.top < probeY && b.bottom > probeY; });
      if (onDark !== lastDark) { lastDark = onDark; seam.classList.toggle('on-dark', onDark); }
    };
    addEventListener('scroll', () => { if (raf === null) raf = requestAnimationFrame(drive); }, { passive: true });
    addEventListener('resize', drive);
    drive();
    requestAnimationFrame(() => seam.classList.add('on'));
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  const toast = (msg) => {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 2600);
  };

  /* ---------- Cart drawer ---------- */
  const drawer = $('#CartDrawer');
  const cartMode = document.body.dataset.cartType || 'drawer';
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const setCount = (n) => $$('[data-bag-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });

  const renderDrawer = (cart) => {
    if (!drawer) return;
    const body = $('.drawer__body', drawer);
    const foot = $('.drawer__foot', drawer);
    setCount(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = `<div class="drawer__empty"><p class="h3">${esc(drawer.dataset.emptyTitle)}</p><a class="btn" href="${esc(drawer.dataset.shopUrl)}">${esc(drawer.dataset.emptyCta)}</a></div>`;
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map((item, i) => `
      <div class="line-item" data-line="${i + 1}">
        <a class="line-item__media" href="${esc(item.url)}">${item.image ? `<img src="${esc(item.image)}${item.image.includes('?') ? '&' : '?'}width=200" alt="${esc(item.product_title)}" width="92" height="115" loading="lazy">` : ''}</a>
        <div>
          <a class="line-item__title" href="${esc(item.url)}">${esc(item.product_title)}</a>
          ${item.variant_title ? `<div class="line-item__meta">${esc(item.variant_title)}</div>` : ''}
          <div class="line-item__actions">
            <div class="qty">
              <button type="button" data-qty-step="-1" aria-label="Decrease quantity">−</button>
              <input type="number" min="0" value="${item.quantity}" aria-label="Quantity" data-qty-input>
              <button type="button" data-qty-step="1" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="line-item__remove" data-remove>${esc(drawer.dataset.removeLabel)}</button>
          </div>
        </div>
        <span class="price">${formatMoney(item.final_line_price)}</span>
      </div>`).join('');
    $('[data-subtotal]', drawer).textContent = formatMoney(cart.total_price);
  };

  const fetchCart = () => fetch(`${window.routes.root_url.replace(/\/$/, '')}/cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

  const openDrawer = async () => {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    document.documentElement.style.overflow = 'hidden';
    $('.drawer__close', drawer)?.focus();
    try { renderDrawer(await fetchCart()); } catch (e) { /* keep server-rendered state */ }
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    document.documentElement.style.overflow = '';
  };
  window.zevOpenCart = openDrawer;

  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
    if (cartMode !== 'drawer' || !drawer) return;
    e.preventDefault();
    openDrawer();
  }));
  drawer?.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); menu?.classList.remove('open'); document.documentElement.style.overflow = ''; } });

  const changeLine = async (line, quantity) => {
    const res = await fetch(`${window.routes.cart_change_url}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!res.ok) throw new Error('change failed');
    return res.json();
  };

  // Line controls work in both the drawer and the cart page
  document.addEventListener('click', async (e) => {
    const lineEl = e.target.closest('.line-item[data-line]');
    if (!lineEl) return;
    const input = $('[data-qty-input]', lineEl);
    const step = e.target.closest('[data-qty-step]');
    const remove = e.target.closest('[data-remove]');
    if (!step && !remove) return;
    e.preventDefault();
    const q = remove ? 0 : Math.max(0, Number(input.value) + Number(step.dataset.qtyStep));
    lineEl.style.opacity = '.5';
    try {
      const cart = await changeLine(Number(lineEl.dataset.line), q);
      if (lineEl.closest('#CartDrawer')) renderDrawer(cart);
      else location.reload();
    } catch (err) { lineEl.style.opacity = ''; }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-qty-input]');
    const lineEl = input?.closest('.line-item[data-line]');
    if (!lineEl) return;
    try {
      const cart = await changeLine(Number(lineEl.dataset.line), Math.max(0, Number(input.value)));
      if (lineEl.closest('#CartDrawer')) renderDrawer(cart); else location.reload();
    } catch (err) { /* noop */ }
  });

  /* ---------- Add to bag (product forms and quick add) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (cartMode !== 'drawer' || !drawer) return; // fall back to normal post to /cart
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn?.querySelector('[data-label]');
    const before = label?.textContent;
    btn?.setAttribute('aria-busy', 'true');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(`${window.routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      if (label) label.textContent = window.zevStrings.added;
      await openDrawer();
    } catch (err) {
      toast(err.message);
    } finally {
      btn?.removeAttribute('aria-busy');
      if (btn) btn.disabled = false;
      setTimeout(() => { if (label && before) label.textContent = before; }, 1800);
    }
  });

  /* ---------- Product variant selection ---------- */
  $$('[data-product]').forEach((root) => {
    const json = $('script[data-variants]', root);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = $('input[name="id"]', root);
    const priceEl = $('[data-price]', root);
    const btn = $('[data-add-btn]', root);
    const btnLabel = btn ? $('[data-label]', btn) : null;
    const optionSets = $$('fieldset[data-option-index]', root);

    const selected = () => optionSets.map((fs) => $('input:checked', fs)?.value);
    const update = () => {
      const opts = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      optionSets.forEach((fs) => {
        const idx = Number(fs.dataset.optionIndex);
        const out = $('[data-selected-value]', fs);
        if (out) out.textContent = opts[idx] || '';
        $$('input', fs).forEach((inp) => {
          const test = opts.slice(); test[idx] = inp.value;
          const ok = variants.some((x) => x.available && x.options.every((o, i) => o === test[i]));
          inp.nextElementSibling?.classList.toggle('unavailable', !ok);
        });
      });
      if (!v) {
        if (btn) btn.disabled = true;
        if (btnLabel) btnLabel.textContent = window.zevStrings.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = v.compare_at_price > v.price
          ? `<s>${formatMoney(v.compare_at_price)}</s><span class="price--sale">${formatMoney(v.price)}</span>`
          : formatMoney(v.price);
      }
      if (btn) btn.disabled = !v.available;
      if (btnLabel) btnLabel.textContent = v.available ? window.zevStrings.addToBag : window.zevStrings.soldOut;
      if (v.featured_media && root.dataset.mediaJump !== 'false') {
        const m = $(`[data-media-id="${v.featured_media.id}"]`, root);
        if (m && root.dataset.ready) m.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      if (root.dataset.ready) history.replaceState({}, '', url);
    };
    root.addEventListener('change', (e) => { if (e.target.closest('fieldset[data-option-index]')) update(); });
    update();
    root.dataset.ready = '1';
  });

  /* ---------- Quantity steppers on the product page ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value) + Number(b.dataset.step));
  });

  /* ---------- Lookbook drift (scroll-scrubbed horizontal rail) ---------- */
  $$('.lookbook').forEach((lb) => {
    const rail = $('.lookbook__rail', lb);
    let onScreen = false;
    let raf = null;
    let last = -1;
    new IntersectionObserver(([e]) => { onScreen = e.isIntersecting; if (onScreen) tick(); }).observe(lb);
    const tick = () => {
      raf = null;
      if (!onScreen || reduced() || innerWidth <= 720) return;
      const r = lb.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (innerHeight - r.top) / (innerHeight + r.height)));
      const travel = Math.max(0, rail.scrollWidth - innerWidth);
      const x = Math.round(p * travel);
      if (x !== last) { last = x; rail.style.setProperty('--lb', x); }
    };
    addEventListener('scroll', () => { if (raf === null) raf = requestAnimationFrame(tick); }, { passive: true });
  });

  /* ---------- Press quotes ---------- */
  $$('[data-press]').forEach((root) => {
    const slides = $$('.press__slide', root);
    const tabs = $$('.press__logos button', root);
    if (slides.length < 2) return;
    let i = 0;
    let timer;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('active', k === i));
      tabs.forEach((t, k) => { t.classList.toggle('active', k === i); t.setAttribute('aria-selected', k === i); });
    };
    const start = () => { if (!reduced()) timer = setInterval(() => go(i + 1), 6500); };
    tabs.forEach((t, k) => t.addEventListener('click', () => { clearInterval(timer); go(k); start(); }));
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', () => { clearInterval(timer); start(); });
    start();
  });

  /* ---------- The promise: press and hold to sew the seam ---------- */
  $$('[data-promise]').forEach((root) => {
    const btn = $('.promise__btn', root);
    const path = $('.promise__thread', root);
    if (!btn || !path) return;
    const len = Math.ceil(path.getTotalLength());
    root.style.setProperty('--len', len);
    const HOLD_MS = 1600;
    let v = 0;
    let holding = false;
    let raf = null;
    let lastT = 0;
    let lastWritten = -1;
    const finish = () => {
      v = 1; root.style.setProperty('--hold', 1);
      root.classList.add('sewn');
      btn.setAttribute('aria-pressed', 'true');
      const done = btn.dataset.doneLabel;
      const l = $('[data-label]', btn);
      if (done && l) l.textContent = done;
    };
    const loop = (t) => {
      const dt = Math.min(64, t - (lastT || t)); lastT = t;
      v += (holding ? 1 : -1.6) * dt / HOLD_MS;
      v = Math.min(1, Math.max(0, v));
      const r = Math.round(v * 500) / 500;
      if (r !== lastWritten) { lastWritten = r; root.style.setProperty('--hold', r); }
      if (v >= 1) { finish(); raf = null; lastT = 0; return; }
      if (!holding && v <= 0) { raf = null; lastT = 0; return; }
      raf = requestAnimationFrame(loop);
    };
    const down = (e) => {
      if (root.classList.contains('sewn')) return;
      if (e.type === 'keydown' && e.key !== ' ' && e.key !== 'Enter') return;
      if (e.type === 'keydown' && e.repeat) return;
      e.preventDefault();
      if (reduced()) { finish(); return; }
      holding = true;
      if (raf === null) raf = requestAnimationFrame(loop);
    };
    const up = () => { holding = false; if (raf === null && v > 0 && v < 1) raf = requestAnimationFrame(loop); };
    btn.addEventListener('pointerdown', down);
    btn.addEventListener('keydown', down);
    ['pointerup', 'pointerleave', 'pointercancel', 'keyup', 'blur'].forEach((ev) => btn.addEventListener(ev, up));
    matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (m) => { if (m.matches) finish(); });
    if (reduced()) finish();
  });
})();
